import { StyledImageLogo } from '../TheWestHeader.styled'
import { createHeaderLogo, LogoProps } from './createHeaderLogo'

const logoFile = require('./images/masthead-the-kimberley-echo.png')

const props: LogoProps = {
    alt: 'The Kimberley Echo',
    src: logoFile,
    heights: {
        desktop: 82,
        tablet: 70,
        mobile: 50,
    },
    ampInitialSize: {
        width: 618,
        height: 92,
    },
    verticalSpacing: 7,
}

export default createHeaderLogo(StyledImageLogo, props)
